<template>
  <div class="feedback-detail-container">
    <h2>评价与反馈详情</h2>
    <el-card shadow="hover">
      <el-descriptions title="基本信息" :column="2">
        <el-descriptions-item label="ID">{{ feedbackDetail.id }}</el-descriptions-item>
        <el-descriptions-item label="用户ID">{{ feedbackDetail.user_id }}</el-descriptions-item>
        <el-descriptions-item label="用户名称">{{ feedbackDetail.user?.name || '未知' }}</el-descriptions-item>
        <el-descriptions-item label="类型">{{ feedbackDetail.type === 'complaint' ? '投诉' : '建议' }}</el-descriptions-item>
        <el-descriptions-item label="标题">{{ feedbackDetail.title }}</el-descriptions-item>
        <el-descriptions-item label="状态">{{ getStatusName(feedbackDetail.status) }}</el-descriptions-item>
        <el-descriptions-item label="提交时间">{{ formatDate(feedbackDetail.created_at) }}</el-descriptions-item>
        <el-descriptions-item label="处理时间">{{ formatDate(feedbackDetail.processed_at) || '-' }}</el-descriptions-item>
        <el-descriptions-item label="内容" :span="2">{{ feedbackDetail.content || '-' }}</el-descriptions-item>
        <el-descriptions-item label="处理备注" :span="2">{{ feedbackDetail.processing_notes || '-' }}</el-descriptions-item>
      </el-descriptions>
      
      <div class="detail-actions">
        <el-button @click="handleBack">返回</el-button>
        <el-button type="primary" @click="handleProcess" :disabled="feedbackDetail.status !== 'pending'">处理</el-button>
        <el-button type="warning" @click="handleClose" :disabled="feedbackDetail.status === 'closed'">关闭</el-button>
      </div>
    </el-card>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { ElMessage } from 'element-plus';
import request from '../../api/axios';

export default {
  name: 'FeedbackDetail',
  setup() {
    const router = useRouter();
    const route = useRoute();
    const feedbackId = route.params.id;
    
    const feedbackDetail = ref({
      id: '',
      user_id: '',
      type: 'suggestion',
      title: '',
      content: '',
      status: 'pending',
      created_at: '',
      processed_at: null,
      processing_notes: ''
    });
    
    // 获取评价与反馈详情
    const fetchFeedbackDetail = async () => {
      try {
        const response = await request({
          url: `/manage/feedback/${feedbackId}`,
          method: 'get'
        });
        feedbackDetail.value = response.data;
      } catch (error) {
        ElMessage.error('获取评价与反馈详情失败');
        console.error(error);
        router.push('/feedbacks/list');
      }
    };
    
    // 页面加载时获取评价与反馈详情
    onMounted(() => {
      fetchFeedbackDetail();
    });
    
    // 获取状态名称
    const getStatusName = (status) => {
      const statusMap = {
        'pending': '待处理',
        'processed': '已处理',
        'closed': '已关闭'
      };
      return statusMap[status] || status;
    };
    
    // 格式化日期
    const formatDate = (dateStr) => {
      if (!dateStr) return '-';
      const date = new Date(dateStr);
      return date.toLocaleString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      });
    };
    
    // 返回列表页面
    const handleBack = () => {
      router.push('/feedbacks/list');
    };
    
    // 处理评价与反馈
    const handleProcess = async () => {
      try {
        await request({
          url: `/manage/feedback/${feedbackId}/process`,
          method: 'post'
        });
        ElMessage.success('处理成功');
        fetchFeedbackDetail();
      } catch (error) {
        ElMessage.error('处理失败');
        console.error(error);
      }
    };
    
    // 关闭评价与反馈
    const handleClose = async () => {
      try {
        await request({
          url: `/manage/feedback/${feedbackId}`,
          method: 'put',
          data: {
            status: 'closed'
          }
        });
        ElMessage.success('关闭成功');
        fetchFeedbackDetail();
      } catch (error) {
        ElMessage.error('关闭失败');
        console.error(error);
      }
    };
    
    return {
      feedbackDetail,
      getStatusName,
      formatDate,
      handleBack,
      handleProcess,
      handleClose
    };
  }
};
</script>

<style scoped>
.feedback-detail-container {
  padding: 20px;
}

.feedback-detail-container h2 {
  margin-bottom: 20px;
  color: #333;
}

.detail-actions {
  margin-top: 20px;
  display: flex;
  justify-content: flex-start;
}

.detail-actions .el-button {
  margin-right: 10px;
}
</style>